import { useLogout } from '@auth';
import { LoadingLayout, RedRingOfDeathIcon } from '@core/components';
import { routes } from '@core/routes';
import { Container, Heading, Button, ButtonType } from '@soteria/design-system-ve';
import { useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import * as styles from './ErrorPage.css';

export function ErrorPage() {
  const { logout, isLoggingOut } = useLogout();
  const navigate = useNavigate();

  const handleReturnToLogin = useCallback(async () => {
    await logout();
    navigate(routes.login);
  }, [logout, navigate]);

  const handleGoBack = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  // Show loading during logout to prevent any flash of redirect UI
  if (isLoggingOut) {
    return <LoadingLayout />;
  }

  return (
    <Container className={styles.container}>
      <div className={styles.iconContainer}>
        <RedRingOfDeathIcon size={120} />
      </div>
      <div className={styles.messageContainer}>
        <Heading level="h1">These aren't the droids you're looking for</Heading>
        <Link className={styles.supportLink} to="#">
          Contact the nearest Jedi council member for support
        </Link>
      </div>
      <div className={styles.buttonContainer}>
        <Button buttonType={ButtonType.Primary} disabled={isLoggingOut} onClick={handleReturnToLogin}>
          RETURN TO LOGIN
        </Button>
        <Button buttonType={ButtonType.Secondary} onClick={handleGoBack}>
          GO BACK
        </Button>
      </div>
    </Container>
  );
}
